import { useContext } from 'react';
import {
  TableBulkActionsModeContext,
  TableBulkActionsModeContextValue,
} from './TableBulkActionsModeContext';

export function useTableBulkActions() {
  const contextValue = useContext<TableBulkActionsModeContextValue | undefined>(
    TableBulkActionsModeContext,
  );
  if (!contextValue) {
    throw new Error(
      'must use useTableBulkActions within TableBulkActionsModeProvider',
    );
  }
  return contextValue;
}
